export default "__VITE_ASSET__a0gpHPWK__"